<template>
  <li
    :class="classes"
    :title="description"
    :aria-label="accessibleForecastLabel"
    v-on="$listeners"
  >
    <time
      :datetime="time.toISOString()"
      class="forecast-row__time"
      data-test-id="forecast-item-time"
    >
      {{ label }}
    </time>
    <div class="forecast-row__condition">
      <EConditionIcon
        :current="time"
        :code="code"
        :sunrise="sunrise"
        :sunset="sunset"
        class="forecast-row__icon"
      />
    </div>
    <div class="forecast-row__temperatures">
      <span class="forecast-row__temperature" data-test-id="forecast-item-temperature">
        {{ temperature }}°
      </span>
      <span
        v-if="secondaryTemperature !== null"
        class="forecast-row__temperature forecast-row__temperature--secondary"
      >
        {{ secondaryTemperature }}°
      </span>
    </div>
  </li>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';
import EConditionIcon from '~/components/weather/icons/condition-icon';
import EForecastItem from './item';
import a11yMixin from './a11y-mixin';

export default {
  name: 'EForecastRow',
  components: {
    EConditionIcon,
  },
  mixins: [classes, a11yMixin],
  props: {
    ...EForecastItem.props,
    // we want all ForecastItem props except this one
    selectable: undefined,
  },
};
</script>

<style lang="scss" scoped>
.forecast-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: $space-1s $space-l;
  cursor: pointer;
}

.forecast-row--selected {
  font-weight: $font-weight-1l;
  cursor: default;
}

.forecast-row__time {
  flex: 0 0 48%;

  .forecast-row--selected & {
    text-decoration: none;
  }

  .forecast-row:hover &,
  .forecast-row:focus & {
    text-decoration: underline;
  }
}

.forecast-row__condition {
  flex: 1 0 auto;
  max-width: none;
}

.forecast-row__icon {
  width: $icon-size-m;
  height: $icon-size-m;
  vertical-align: bottom;
}

.forecast-row__temperatures {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  text-align: right;
  font-size: inherit;
}

.forecast-row__temperature {
  flex: 0 0 $space-2l;
}

.forecast-row__temperature--secondary {
  color: var(--color-text-secondary);
}
</style>
